import { _ } from "../../../../core/polyglot/polyglot.js";
import { configureDialog } from "../../../../core/widgets/dialogs/dialogs.js";
import {
	required,
	validateAll,
} from "../../../../core/widgets/forms/validators.js";

/**
 *  I am the widget used to create a directory.
 *  I display a popup asking the user about the name
 *  of the directory he wants to create.
 *
 *  I should only be used through the proper command.
 */
export default function createDirectoryDialog(command) {
	const newFolder = {};
	const folder = command.getFolder();

	function createFolder() {
		command.setDirectoryName(newFolder.name);
		command.doPerform();
	}

	function validateName(name) {
		folder.children().forEach((each) => {
			if (each.name() !== name) {
				return;
			}
			throw _(
				"This name is already used by a file or a folder in this directory",
			);
		});
	}

	return configureDialog({
		title: _("New directory"),
		formSpec: {
			actionsClass: "modal-footer",
			model: newFolder,
			saveAction: createFolder,
			saveLabel: _("Create directory"),
			dataTestName: "confirm-create-directory",
		},
		formBuilder: (form) => {
			form.input({
				attribute: "name",
				label: _("Directory name"),
				validator: validateAll(required(), validateName),
			});
		},
	});
}
